export const SET_FILTERED_TABLE_DATA = 'SET_FILTERED_TABLE_DATA';

export const setFilteredTableDataAction = payload => ({ type: SET_FILTERED_TABLE_DATA, payload });
